import user from '@/api/user'
import tenant from '@/api/tenant'
import event from '@/api/event'
import metaEvent from '@/api/meta_event'
import eventAttribute from '@/api/eventAttribute'
import eventApp from '@/api/eventApp'
import eventGroup from '@/api/eventGroup'
import project from '@/api/project'
import application from '@/api/application'
import applicationAudit from '@/api/application_audit'
import metaData from '@/api/meta_data'
import analyseEvent from '@/api/analyse_event'
import analyseFunnel from '@/api/analyse_funnel'
import dashboard from '@/api/dashboard'
import businessChannel from '@/api/business_channel'
import analyseRetained from '@/api/analyse_retained'
import analysePath from '@/api/analyse_path'
import panelComponent from '@/api/panel_component'
import privilege from '@/api/privilege'
import role from '@/api/role'
import channelLink from '@/api/channel_link'
import analyseOverall from '@/api/analyse_overall'
import analyseLtv from '@/api/analyse_ltv'
import aliyunLog from '@/api/log_aliyun'
import ckLog from '@/api/log_ck'
import activity from '@/api/activity_manage'
import warningManage from '@/api/warning_manage'
import channelManage from '@/api/channel_manage'
import analysePage from '@/api/analyse_page'
import analyseLanding from '@/api/analyse_landing'
import analyseCustom from '@/api/analyse_custom'
import virtualEvent from '@/api/virtual_event'
import businessChannelRule from '@/api/business_channel_rule'
import textLink from '@/api/text_link'
import analyseDistribution from '@/api/analyse_distribution'
import groupUser from '@/api/user_group'
import analyseAttribution from '@/api/analyse_attribution'
import analyseSession from '@/api/analyse_session'
import analyseChannel from '@/api/analyse_channel'
import analyseInterval from '@/api/analyse_interval'
import pageAttribute from '@/api/page_attribute'
import synSource from '@/api/mh_instance_config_source'
import synTask from '@/api/mh_instance_config_task'
import systemDashboard from '@/api/dashboard_system'
import permissions from '@/api/permissions'
import operationLog from './operationLog'

export default {
  user,
  tenant,
  event,
  metaEvent,
  eventAttribute,
  eventApp,
  eventGroup,
  project,
  application,
  applicationAudit,
  metaData,
  analyseEvent,
  analyseFunnel,
  dashboard,
  businessChannel,
  analyseRetained,
  analysePath,
  panelComponent,
  role,
  privilege,
  channelLink,
  analyseOverall,
  analyseLtv,
  aliyunLog,
  ckLog,
  activity,
  channelManage,
  analysePage,
  warningManage,
  analyseCustom,
  analyseLanding,
  virtualEvent,
  businessChannelRule,
  textLink,
  analyseDistribution,
  analyseAttribution,
  groupUser,
  analyseChannel,
  analyseInterval,
  pageAttribute,
  analyseSession,
  synSource,
  synTask,
  systemDashboard,
  permissions,
  operationLog
}
